import { render, staticRenderFns } from "./linkAccount.vue?vue&type=template&id=09fad3bc&scoped=true&"
import script from "./linkAccount.vue?vue&type=script&lang=js&"
export * from "./linkAccount.vue?vue&type=script&lang=js&"
import style0 from "./linkAccount.vue?vue&type=style&index=0&id=09fad3bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fad3bc",
  null
  
)

export default component.exports